export default "__VITE_ASSET__D6qHEw17__"